// Import global passive events fix to handle non-passive event listeners
import './utils/global-passive-fix';

import Vue from "vue";
import App from "./App.vue";
import { router } from "./router/router";
import store from "./store/store";
import http from "./services/http.service";
import api from "./services/api";
// import './registerServiceWorker'+
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css";
import i18n from "./language";
import VeeValidate, { Validator } from "vee-validate";
import { isUnique } from "./validations/validations";

import en from "vee-validate/dist/locale/en";
import bg from "vee-validate/dist/locale/bg";
import helpers from "./helpers/helpers";
import moment from "moment";
// eslint-disable-next-line
import extensions from "./helpers/extensions"; // Used
import EventsHub from "./hubs/events-hub";
import TasksHub from "./hubs/tasks-hub";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";


import "@progress/kendo-ui";
import "@progress/kendo-theme-material/dist/all.css";

import { GridInstaller } from "@progress/kendo-grid-vue-wrapper";
import { DataSourceInstaller } from "@progress/kendo-datasource-vue-wrapper";
import { DateinputsInstaller } from "@progress/kendo-dateinputs-vue-wrapper";
import { DropdownsInstaller } from "@progress/kendo-dropdowns-vue-wrapper";
import { MapInstaller } from "@progress/kendo-map-vue-wrapper";
import { LayoutInstaller } from "@progress/kendo-layout-vue-wrapper";
import { InputsInstaller } from "@progress/kendo-inputs-vue-wrapper";


// import vuetify from '@/plugins/vuetify';

// import './registerServiceWorker';
import * as Fingerprint2 from 'fingerprintjs2'

if (store.state.language === "en") {
    require("@progress/kendo-ui/js/cultures/kendo.culture.en-GB");
    require("@progress/kendo-ui/js/messages/kendo.messages.en-GB");
} else {
    require("@progress/kendo-ui/js/cultures/kendo.culture.bg-BG");
    require("@progress/kendo-ui/js/messages/kendo.messages.bg-BG");
}

Vue.use(MaterialDashboard);

// The following Kendo UI components for Vue depend on the current culture:
// Calendar, DateInput, DatePicker, TimePicker, DateTimePicker,NumericTextBox,
// MaskedTextBox(globalized mask literals), Scheduler, Gantt
Vue.use(MapInstaller);
Vue.use(GridInstaller);
Vue.use(DataSourceInstaller);
Vue.use(DateinputsInstaller);
Vue.use(DropdownsInstaller);
Vue.use(LayoutInstaller);
Vue.use(InputsInstaller);

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

// Allow debug builds
Vue.config.devtools = true;

Vue.use(Vuesax);


Validator.extend("unique", {
    validate: isUnique
    // TODO: getMessage is not working for some reason...
    /* getMessage: (field, params, data) => {
        return 'Testtttttt!!!'; //(data && data.message) || 'test';
    } */
});

Vue.use(VeeValidate, {
    events: "input|blur",
    /*    i18nRootKey: 'validations',
    i18n, */
    dictionary: {
        en: en,
        bg: bg
    }
});

Vue.config.productionTip = false;
Vue.prototype.$helpers = helpers;
Vue.prototype.$http = http;
Vue.prototype.$api = api;

moment.locale("bg");
Vue.prototype.$moment = moment;

Vue.use(EventsHub);
Vue.use(TasksHub);

Vue.prototype.$fingerprint = Fingerprint2;

new Vue({
    router,
    store,
    i18n,
    // vuetify, Изключено. Bootstrap-ските класове се объркват от vuetify и не работят правилно
    render: h => h(App)
}).$mount("#app");

// if (module.hot) {
//  module.hot.accept(['./language/en', './language/bg'], function () {
//    i18n.setLocaleMessage('en', require('./language/en').default)
//    i18n.setLocaleMessage('bg', require('./language/bg').default)
//    // Or the following hot updates via $i18n property
//    // app.$i18n.setLocaleMessage('en', require('./en').default)
//    // app.$i18n.setLocaleMessage('ja', require('./ja').default)
//  })
// }
